import type { EngineId } from '@/lib/types'
import { cn } from '@/lib/utils'
import type { EngineBadgeProps, EngineLogoSources } from './EngineBadge.types'
import { mentionBadgeClasses } from './MentionBadge.styles'

const engineLogos: Record<EngineId, EngineLogoSources> = {
  openai: {
    lightTheme: new URL(
      '../assets/engine-logos/openai-logo-dark.svg',
      import.meta.url
    ).href,
    darkTheme: new URL(
      '../assets/engine-logos/openai-logo-light.png',
      import.meta.url
    ).href,
  },
  anthropic: {
    lightTheme: new URL(
      '../assets/engine-logos/claude-logo-dark.svg',
      import.meta.url
    ).href,
    darkTheme: new URL(
      '../assets/engine-logos/claude-logo-light.png',
      import.meta.url
    ).href,
  },
  google: {
    lightTheme: new URL(
      '../assets/engine-logos/google-logo.svg',
      import.meta.url
    ).href,
  },
  xai: {
    lightTheme: new URL(
      '../assets/engine-logos/grok-logo-dark.svg',
      import.meta.url
    ).href,
    darkTheme: new URL(
      '../assets/engine-logos/grok-logo-light.png',
      import.meta.url
    ).href,
  },
  deepseek: {
    lightTheme: new URL(
      '../assets/engine-logos/deepseek-logo.jpeg',
      import.meta.url
    ).href,
    tile: true,
  },
}

export function EngineBadge({ engineId, label, mention }: EngineBadgeProps) {
  const logo = engineLogos[engineId]

  return (
    <span
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded border px-1.5 py-0.5 text-[10px] uppercase',
        mentionBadgeClasses[mention]
      )}
    >
      <span role="img" aria-label={`${label} logo`} className="size-3 shrink-0">
        <img
          src={logo.lightTheme}
          alt=""
          className={cn(
            'size-full object-contain',
            logo.darkTheme && 'dark:hidden',
            logo.tile && 'rounded-sm'
          )}
        />

        {logo.darkTheme && (
          <img
            src={logo.darkTheme}
            alt=""
            className="hidden size-full object-contain dark:block"
          />
        )}
      </span>

      <span data-slot="engine-badge-label">{label}</span>
    </span>
  )
}
